import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { PortalAuthContextService } from '../Services/Authorization/portal-auth.service';

export const portalAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const contextService = inject(PortalAuthContextService);

  if (contextService.isPortalLoggedIn()) {
    return true;
  }

  return router.parseUrl('/noAccess');
};
